import React, { useEffect, useState, useRef } from "react";
import useNotify from "../utils/useNotify";
import { addVendor, getVendorById, editVendor } from "../services/httpCalls";
import {
  Box,
  Typography,
  Grid,
  FormControl,
  InputLabel,
  Input,
  Button,
  Paper,
  MenuItem,
  Select,
  TextField,
  FormHelperText,
  Checkbox,
  FormControlLabel,
} from "@mui/material";
import { MultiSelect } from "../components/multiselect";
import { useRecoilState, useSetRecoilState } from "recoil";
import { vendorDetailsClicked, showloader } from "../store/gloabalState";
import { useLocation, useParams } from "react-router-dom";
import VendorFileModal from "../components/VendorFileModal";
import {
  getPresignedURLVendor,
  setFileVendorMetaData,
} from "../services/httpCalls";
import VendorDownloadDocs from "../components/VendorDownloadDocs";
import { DocList, leiRegex } from "../config/globalVar";
import { cleanObject } from "../utils/onboarding/clean-object";
import { checkFileExtension } from "../utils/check-file-extension";

export default function CreateVendor() {
  const params = useParams();
  const VendorId = params.id;

  const [createVendor, setCreateVendor] = useState({
    name: "",
    country: "",
    email: "",
    address: "",
    leiNumber: "",
  });
  const [suggestedList, setSuggestedList] = useState([]);
  const routerPath = useLocation();
  const [clear, setClear] = useState(false);
  const [editFlag, setEditFlag] = useState(false);
  const [file, setFile] = useState();
  const [vendorDetails, setVendorDetails] =
    useRecoilState(vendorDetailsClicked);
  const [vendorId, setVendorId] = useState();
  const [documentsType, setDocuments] = useState("");
  const [otherType, setOtherDocument] = useState();
  const [otherFlag, setOtherFlag] = useState(false);
  const [vendorfileFlag, setVendorFileFlag] = useState(false);
  const [istypeSelected, setIsTypeSelected] = useState(false);
  const [filename, setFileName] = useState("");
  const [leiFlag, setLeiFlag] = useState(false);
  const [errors, setErrors] = useState({
    name: false,
    address: false,
    country: false,
    email: false,
  })

  const setShowLoader = useSetRecoilState(showloader);
  const pathname = routerPath.pathname;
  const inputfileRef = useRef(null);
  const resetFile = () => {
    inputfileRef.current.value = "";
    setFile("");
  };
  const uploadFileToS3 = (url, file) => {
    return fetch(url, {
      method: "PUT",
      body: file,
      headers: { "Content-Type": file.type },
    });
  };
  let notify = useNotify();
  const uploadDoc = async (e) => {
    setShowLoader(true);
    getPresignedURLVendor(params.id, e[0]?.name)
      .then(async (res) => {
        const url = res?.preSignedUrl;
        await uploadFileToS3(res.preSignedUrl, e[0]).then(async (res) => {
          const newPresSigned = url.split("?")[0];

          const decodedurl = decodeURI(newPresSigned);
          let vendorData = {
            vendorFileMetaList: [
              {
                url: decodedurl,
                vendorDocumentType: documentsType,
              },
            ],
          };
          if (otherType) {
            vendorData.vendorFileMetaList = [
              {
                url: decodedurl,
                vendorDocumentType: "OTHER_DOCUMENT_TYPE",
                otherDocumentType: otherType,
              },
            ];
          }
          await setFileVendorMetaData(params.id, vendorData)
            .then((res) => {
              notify.success("File and Type Upload Success!");
            })
            .catch((err) => {
              console.log(err);
              notify.error("Error Uploading");
            });
        });

        setShowLoader(false);
        setVendorFileFlag(true);
      })
      .catch((error) => {
        notify.error("Not able to Upload the file!");
        console.log("error", error);
        setShowLoader(false);
      });
  };
  useEffect(() => {
    const fetchData = async () => {
      let url_ = window.location.pathname;
      if (pathname === "/addvendor") {
        setEditFlag(false);
        setCreateVendor({
          name: "",
          country: "",
          email: "",
          address: "",
          leiNumber: "",
        });
      } else {
        await preFetchData(url_);
      }
    };
    fetchData();
  }, [pathname]);

  const preFetchData = (url_) => {
    let id_ = url_.trim();
    id_ = url_.split("/")[2];
    setVendorId(id_);
    setEditFlag(true);
    if (Object.keys(vendorDetails).length === 0 && id_) {
      getVendorById(id_).then((res) => {
        setVendorDetails(res);
        setCreateVendor({
          name: res.name,
          country: res.country,
          email: res.email ? res.email : "",
          address: res.address ? res.address : "",
          leiNumber: res?.leiNumber,
        });
      });
    }
    setCreateVendor({
      name: vendorDetails.name,
      country: vendorDetails.country,
      email: vendorDetails.email ? vendorDetails.email : "",
      address: vendorDetails.address ? vendorDetails.address : "",
      leiNumber: vendorDetails?.leiNumber,
    });
  };

  const createVendorFun = async (e) => {
    e.preventDefault();

    if(Object.values(errors).some(error => error === true)){
      return;
    }

    let data = createVendor;

    if (leiFlag) {
      data.leiNumber =
        "LEI number not available as the company has not registered yet";
    } else {
      data = createVendor;
    }
    data.paymentPurposeIdList = suggestedList;

    let cleanData = cleanObject(data)

    addVendor(cleanData)
      .then((res) => {
        notify.success("Added Vendor Successfully!");
        setCreateVendor({
          name: "",
          country: "",
          email: "",
          address: "",
          leiNumber: "",
        });
        setSuggestedList([]);
        setClear(true);
      })
      .catch((err) => {
        notify.error("Not Able to Add Vendor!");
      });
  };

  const editVendorFun = async (e) => {
    e.preventDefault();

    if(Object.values(errors).some(error => error === true)){
      return;
    }

    let data = createVendor;
    if (leiFlag) {
      data.leiNumber =
        "LEI number not available as the company has not registered yet";
    } else {
      data = createVendor;
    }
    data.paymentPurposeIdList = suggestedList;
    let cleanData = cleanObject(data);
    editVendor(cleanData, vendorId)
      .then((res) => {
        notify.success("Updated Vendor Successfully!");
      })
      .catch((err) => {
        notify.error("Not Able to Add Vendor!");
      });
  };

  const sendFileandMetaData = async () => {
    if (file?.length) {
      await uploadDoc(file).then(() => {
        setIsTypeSelected(false);
      });
    } else {
      notify.error("No file selected!");
    }
  };

  const modalData = {
    filename: filename,
    filetype: documentsType,
    otherType: otherType,
  };
  const handleCheckBoxChange = () => {
    setLeiFlag(!leiFlag);
  };

  return (
    <Box sx={{ padding: "1rem" }}>
      <Typography variant="h5" sx={{ paddingBottom: "1rem", fontWeight: 400 }}>
        {editFlag ? "Edit Vendor" : "Create Vendor"}
      </Typography>
      <Grid container spacing={5}>
        <Grid item xs={6}>
          <Box
            component="form"
            validate
            onSubmit={(e) => (editFlag ? editVendorFun(e) : createVendorFun(e))}
          >
            <FormControl
              variant="standard"
              required
              sx={{ width: "300px", display: "block", marginTop: ".5rem" }}
              disabled={editFlag}
              error={errors.name}
            >
              <InputLabel htmlFor="name">Vendor Name</InputLabel>
              <Input
                id="name"
                value={createVendor.name}
                readOnly={editFlag}
                onChange={(e) => {
                  setCreateVendor({
                    ...createVendor,
                    [e.target.id]: e.target.value,
                  })

                  if(e.target.value.length > 100){
                    setErrors((error) => ({
                      ...error,
                      name:true
                    }))
                  } else {
                    setErrors((error) => ({
                      ...error,
                      name:false
                    }))
                  }

                }
              }
                sx={{ width: "100%" }}
              />
              {errors.name && <FormHelperText>Please enter a proper value!</FormHelperText>}
            </FormControl>
            <MultiSelect
              setClear={setClear}
              clear={clear}
              id="purposeSelector"
              label="Suggest Purposes"
              setSuggestedList={setSuggestedList}
              editFlag={editFlag}
              vendorId={vendorId}
            />
            <FormControl
              variant="standard"
              required
              sx={{ width: "300px", display: "block", marginTop: ".5rem" }}
              error={errors.address}
            >
              <InputLabel htmlFor="address">
                Adress(including city and pincode)
              </InputLabel>
              <Input
                id="address"
                value={createVendor.address}
                onChange={(e) => {
                  setCreateVendor({
                    ...createVendor,
                    [e.target.id]: e.target.value,
                  })

                  if(e.target.value.length > 100){
                    setErrors((error) => ({
                      ...error,
                      address:true
                    }))
                  } else {
                    setErrors((error) => ({
                      ...error,
                      address:false
                    }))
                  }
                }
                 
                }
                sx={{ width: "100%" }}
              />
            {errors.address && <FormHelperText>Please enter a proper value!</FormHelperText>}
            </FormControl>
            <FormControl
              variant="standard"
              required
              sx={{ width: "300px", display: "block", marginTop: ".5rem" }}
              disabled={editFlag}
              error={errors.country}
            >
              <InputLabel htmlFor="country">Country</InputLabel>
              <Input
                id="country"
                value={createVendor.country}
                readOnly={editFlag}
                onChange={(e) => {
                  setCreateVendor({
                    ...createVendor,
                    [e.target.id]: e.target.value,
                  })
                  if(e.target.value.length > 100){
                    setErrors((error) => ({
                      ...error,
                      country:true
                    }))
                  } else {
                    setErrors((error) => ({
                      ...error,
                      country:false
                    }))
                  }

                }
                  
                }
                sx={{ width: "100%" }}
              />
              {errors.country && <FormHelperText>Please enter a proper value!</FormHelperText>}
            </FormControl>
            <FormControl
              variant="standard"
              sx={{ width: "300px", display: "block", marginTop: ".5rem" }}
              error={errors.email}
            >
              <InputLabel htmlFor="email">Email</InputLabel>
              <Input
                id="email"
                value={createVendor.email}
                onChange={(e) => {
                  setCreateVendor({
                    ...createVendor,
                    [e.target.id]: e.target.value,
                  })

                  if(e.target.value.length > 100){
                    setErrors((error) => ({
                      ...error,
                      email:true
                    }))
                  } else {
                    setErrors((error) => ({
                      ...error,
                      email:false
                    }))
                  }
                }
                  
                }
                type="email"
                sx={{ width: "100%" }}
              />
            {errors.email && <FormHelperText>Please enter a proper value!</FormHelperText>}
            </FormControl>

            <FormControl
              variant="standard"
              sx={{
                marginTop: ".5rem",
              }}
            >
              <FormControlLabel
                value="top"
                control={<Checkbox onChange={handleCheckBoxChange} />}
                label="LEI number not available as the company has not registered yet"
              />
            </FormControl>

            <Box>
              {leiFlag ? (
                ""
              ) : (
                <>
                  <FormControl
                    variant="standard"
                    required
                    sx={{
                      width: "300px",
                      display: "block",
                      marginTop: ".2rem",
                    }}
                    error={!!errors.leiNumber}
                  >
                    <InputLabel htmlFor="leiNumber">LEI Number</InputLabel>
                    <Input
                      id="leiNumber"
                      value={createVendor.leiNumber}
                      onChange={(e) => {
                        setCreateVendor({
                          ...createVendor,
                          [e.target.id]: e.target.value,
                        })

                        if(e.target.value.length > 100 || !leiRegex.test(e.target.value)){
                          setErrors((error) => ({
                            ...error,
                            leiNumber:true
                          }))
                        } else {
                          setErrors((error) => ({
                            ...error,
                            leiNumber:false
                          }))
                        }
                      }
                    }
                      type="text"
                      sx={{ width: "100%" }}
                    />
                    {errors.leiNumber && <FormHelperText>please enter a proper value!</FormHelperText>}
                  </FormControl>
                </>
              )}
            </Box>
            {editFlag ? (
              <Button type="submit" variant={"contained"} sx={{ mt: "2rem" }}>
                Update Vendor
              </Button>
            ) : (
              <Button type="submit" variant={"contained"} sx={{ mt: "2rem" }}>
                Create Vendor
              </Button>
            )}
          </Box>
        </Grid>
        {editFlag ? (
          <Grid item xs={6}>
            <Box>
              <Paper
                sx={{
                  width: "350px",
                  height: "auto",
                  mb: 2,
                  p: 2,
                }}
                elevation={2}
              >
                <Typography
                  sx={{
                    fontSize: "18px",
                    fontWeight: "bold",
                  }}
                >
                  You can upload files:
                </Typography>
                <Box>
                  <FormControl
                    fullWidth
                    sx={{
                      mt: "20px",
                    }}
                  >
                    <InputLabel>Documents</InputLabel>
                    <Select
                      value={documentsType}
                      label="Documents"
                      onChange={(e) => {
                        setDocuments(e.target.value);
                        setIsTypeSelected(true);
                        if (e.target.value === "OTHER_DOCUMENT_TYPE") {
                          setOtherFlag(true);
                        } else {
                          setOtherFlag(false);
                          setIsTypeSelected(true);
                          setOtherDocument("");
                        }
                      }}
                    >
                      {DocList.map((item, index) => {
                        return (
                          <MenuItem value={item.value} key={index}>
                            {item.text}
                          </MenuItem>
                        );
                      })}
                    </Select>
                  </FormControl>
                </Box>
                {documentsType ? (
                  <Box mt={2}>
                    <span>
                      Type of Document:{" "}
                      <span
                        style={{
                          fontWeight: "bold",
                        }}
                      >
                        {documentsType}
                      </span>
                    </span>
                  </Box>
                ) : (
                  ""
                )}
                {otherFlag ? (
                  <>
                    <Box>
                      <FormControl
                        fullWidth
                        sx={{
                          mt: 3,
                        }}
                      >
                        <TextField
                          label="Others"
                          placeholder="please specify other type of docs"
                          onChange={(e) => {
                            setOtherDocument(e.target.value);
                          }}
                        ></TextField>
                        <FormHelperText>
                          <span> Uploading type: {otherType}</span>
                        </FormHelperText>
                      </FormControl>
                    </Box>
                  </>
                ) : (
                  ""
                )}
                <Box marginTop={3}>
                  <FormControl>
                    <TextField
                      type="file"
                      inputRef={inputfileRef}
                      variant="outlined"
                      label="Upload File"
                      onChange={(e) => {
                        if (e.target.files?.length > 0) {
                          if(!checkFileExtension(e.target.files[0]?.name)){
                            notify.error("Please upload a file with proper extension!")
                          }
                          setFile(e.target.files);
                          setFileName(e.target.files[0]?.name);
                        } else {
                          notify.error("No File Selected");
                          resetFile();
                        }
                      }}
                      InputLabelProps={{ shrink: true }}
                      key={""}
                    />
                  </FormControl>
                  <Box
                    sx={{
                      mt: 2,
                    }}
                  >
                    <VendorFileModal
                      setVendorFileFlag={setVendorFileFlag}
                      vendorfileFlag={vendorfileFlag}
                      modalData={modalData}
                      setDocuments={setDocuments}
                      setOtherDocument={setOtherDocument}
                      setOtherFlag={setOtherFlag}
                      resetFile={resetFile}
                    />
                  </Box>
                </Box>
                <Button
                  variant="contained"
                  onClick={sendFileandMetaData}
                  disabled={!istypeSelected}
                >
                  Submit
                </Button>
              </Paper>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  width: "350px",
                }}
              >
                <VendorDownloadDocs VendorId={VendorId} />
              </Box>
            </Box>
          </Grid>
        ) : (
          ""
        )}
      </Grid>
    </Box>
  );
}
